import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../../../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MerchantService } from "../../../services/merchant.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../../../models/create-result';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { CountryViewModel } from '../../../models/country-view-model';
import { TerminalService } from '../../../services/terminal.service';
import { ContactDetailsViewModel } from '../../../models/contact-details-view-model';
import { ConfirmationDialogComponent } from '../../../partials/confirmation-dialog/confirmation-dialog.component';
import { TerminalConfigService } from '../../../services/terminal-config.service';
import { MerchantTerminalConfigViewModel } from '../../../models/merchant-terminal-config-view-model';
import { TerminalContactsViewModel } from '../../../models/terminal-contacts-view-model';
import { AddUpdateTerminalInteractionViewModel } from '../../../models/add-update-terminal-interaction-view-model';
import { AddUpdateTerminalSignUpViewModel, TerminalSignUpDownloadModel } from '../../../models/add-update-terminal-sign-up-view-model';
import { ChangeDetectorRef } from '@angular/core';
import { DecodedNameLocation } from '../../../models/decoded-name-location -view-model';
import { ConstantValues } from '../Common-helpers/constant-values';
import { AddUpdateMerchantViewModel } from '../../../models/add-update-merchant-view-model';
import { TerminalSignUpNotesViewModel } from '../../../models/terminal-sign-up-notes';
import { validateFormHelper } from '../Common-helpers/validate-form';
import { IdTextPair } from '../../../models/id-text-pair';
import { merchantTerminalsLink } from '../../../models/merchant-terminals-link';
import { CommsProfileService } from '../../../services/comms-profile.service';
import { ProductProfileService } from '../../../services/product-profile.service';
import { TerminalCapabilityService } from '../../../services/terminal-capability.service';
import { AddUpdateTerminalViewModel } from '../../../models/add-update-terminal-view-model';
import { debug } from 'util';
import { TerminalSignUpViewModel } from '../../../models/terminal-signup-view-model';
import { TerminalViewModel } from '../../../models/terminal-view-model';
import { Select2OptionData } from 'ng-select2';
import { TaTermConfigViewModel } from '../../../models/ta-term-config-view-model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'signup-terminal-component',
  templateUrl: './signup-terminal.component.html',
})

export class SignupTerminalComponent extends validateFormHelper implements OnInit {

  private dtTrigger: Subject<boolean> = new Subject();
  @ViewChild(DataTableDirective)
  private dtElement: DataTableDirective;
  private terminalList: AddUpdateTerminalSignUpViewModel[] = [];
  private TerminalContacts: TerminalContactsViewModel[] = [];
  private TerminalNotes: TerminalSignUpNotesViewModel[] = [];
  private countryDetails: CountryViewModel;
  private merchantTerminalDefaultConfig: MerchantTerminalConfigViewModel;
  private bankingParamDownlWindowUpdateAll: AddUpdateTerminalInteractionViewModel[] = [];
  private createResult: CreateResult;
  areaBuffer = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  private terminalCount: number;
  public submitted: boolean = false;
  public TerminalFormGroup: FormGroup;
  public deviceMakeList: IdTextPair[] = [];
  public deviceModelList: IdTextPair[] = [];
  public deviceModels: IdTextPair[] = [];
  public displayContent = true;
  public deviceList: TerminalSignUpDownloadModel[] = [];
  public deviceListBulk: TerminalSignUpDownloadModel[] = [];
  public terminalDeliveryMethod: IdTextPair[] = [];
  public _addUpdateMerchantViewModel: AddUpdateMerchantViewModel;
  public _contactDetailsViewModel: ContactDetailsViewModel;
  private parameterDownloadInteractionDays: IdTextPair[] = [];
  private terminalInteractionBankingWindowTimes: IdTextPair[] = [];
  private terminalInteractionParameterTimes: IdTextPair[] = [];
  private governmentalOptions: IdTextPair[] = [];
  public termTypes: IdTextPair[] = [];
  public capList: IdTextPair[] = [];
  public proList: IdTextPair[] = [];
  public comList: IdTextPair[] = [];
  public retailDropdownList = [
    { item_id: 1, item_text: 'Purchase' },
    { item_id: 2, item_text: 'Purchase with Cashback' },
    { item_id: 3, item_text: 'Cash Withdrawal' },
    { item_id: 4, item_text: 'Cancel' },
    { item_id: 5, item_text: 'Refund' },
    { item_id: 6, item_text: 'Pre-Auth' },
    { item_id: 7, item_text: 'Pre-Auth Completion' },
    { item_id: 8, item_text: 'Balance Inquiry' },
    { item_id: 9, item_text: 'Deposit' },
    { item_id: 10, item_text: 'Available Funds Inquiry' }
  ];
  public adminDropdownList = [
    { item_id: 1, item_text: 'Exit' },
    { item_id: 2, item_text: 'Settings' },
    { item_id: 3, item_text: 'Device Settings' },
    { item_id: 4, item_text: 'Reports' },
    { item_id: 5, item_text: 'History' },
    { item_id: 6, item_text: 'Re-print' },
    { item_id: 7, item_text: 'Operator' },
    { item_id: 8, item_text: 'Batch' },
    { item_id: 9, item_text: 'Hots Totals' },
    { item_id: 10, item_text: 'Ping' }
  ];
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All'
  };
  public isbulkOrder: boolean = false;
  public btnAddTerminal: boolean = true;
  public bulkOrderConfirmation: string;
  public deviceOwnershipTypes: IdTextPair[] = [
    { id: "Rental", text: 'Rental' },
    { id: "Rent to purchase", text: 'Rent to purchase' },
    { id: "Outright purchase", text: 'Outright purchase' },
    { id: "Other", text: 'Other' }
  ];
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(
    private _terminalConfigService: TerminalConfigService,
    private _userDataStore: UserDataStoreService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _merchantService: MerchantService,
    private cdr: ChangeDetectorRef,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    public _merchantTerminalsLink: merchantTerminalsLink) {
    super();
    this._ngxUiLoaderService.start();
    this.initObjects();
    this._ngxUiLoaderService.stop();
  }

  ngAfterViewInit(): void {
    this.TerminalFormGroup.controls["country"].setValue('ZA');
    this.TerminalFormGroup.controls["region"].setValue('GP');
  }

  public async initObjects(): Promise<void> {

    this.setFormValue();
    this.deviceMakeList = (await this._terminalService.GetDeviceMakes()).map((x) => {
      return { id: x.id.toString(), text: x.make }
    });

    this.deviceModelList = (await this._terminalService.GetDeviceModels()).map((x) => {
      return { id: x.id.toString(), text: x.model }
    });
    this.deviceModels = this.deviceModelList;

    this.merchantTerminalDefaultConfig = await this._terminalConfigService.GetDefaultConfigByParticipantId(this._userDataStore.selectedParticipant.id);
    if (this.merchantTerminalDefaultConfig == null || this.merchantTerminalDefaultConfig == undefined) {
      //this.raiseDanger = true;
      //this.danger = "There is no default terminal config for this participant. Contact system administrator.";
    }
    else {
    }

    this.termTypes = (await this._terminalService.GetTermTypes()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this._merchantTerminalsLink.termTypes = this.termTypes;

    this.capList = (await this._terminalCapabilityService.GetTerminalCapabilitiesForParticipantOrAll()).map((x) => {
      return { id: x.capabilityProfileId.toString(), text: x.capabilityProfileName }
    });
    this.comList = (await this._commsProfileService.GetCommsProfilesForParticipantOrAll()).map((x) => {
      return { id: x.commsProfileId.toString(), text: x.description }
    });
    this.proList = (await this._productProfileService.GetProductProfiles()).map((x) => {
      return { id: x.profileId.toString(), text: x.productProfile }
    });
  }

  private setFormValue() {
    this.terminalCount = 1;
    this.parameterDownloadInteractionDays = ConstantValues.parameterDownloadInteractionDays;
    this.terminalInteractionBankingWindowTimes = ConstantValues.terminalInteractionBankingWindowTimes;
    this.terminalInteractionParameterTimes = ConstantValues.terminalInteractionParameterTimes;
    this.governmentalOptions = ConstantValues.governmentalOptions;
    this.terminalDeliveryMethod = ConstantValues.terminalDeliveryMethod;

    this.TerminalFormGroup = this._formBuilder.group({
      merchantId: new FormControl(''),
      terminalId: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern('^[a-zA-Z0-9]+$')])],
      terminalNumber: ['', Validators.compose([Validators.required, Validators.maxLength(4)])],
      deviceOwnership: new FormControl('', Validators.compose([Validators.required])),
      deviceMake: new FormControl('', Validators.compose([Validators.required])),
      retail: new FormControl([]),
      admin: new FormControl([]),
      deviceModel: new FormControl('', Validators.compose([Validators.required])),
      terminaldelivery: new FormControl('', Validators.compose([Validators.required])),
      terminalType: new FormControl(''),
      productProfile: new FormControl(''),
      terminalCapabilities: new FormControl(''),
      commsProfile: new FormControl(''),
      isTerminalActive: new FormControl(true),
      sameAsMerchantAddress: new FormControl(false),//useMerchantAddress = true;
      isManualPan: new FormControl(''),
      isContactless: new FormControl(''),
      bankingWindowTime: new FormControl(''),
      parameterDownloadDay: new FormControl(''),
      parameterDownloadWindowTime: new FormControl(''),
      nameSurname: new FormControl(''),
      emailAddress: new FormControl(''),
      cell: new FormControl(''),
      address: new FormControl('', Validators.compose([Validators.required])),
      region: new FormControl('', Validators.compose([Validators.required])),
      city: new FormControl('', Validators.compose([Validators.required])),
      postalcode: new FormControl('', Validators.compose([Validators.required])),
      country: new FormControl('', Validators.compose([Validators.required])),
      bulkOrder: new FormControl(false),
      numberOfTerminals: new FormControl(''),
      notes: new FormControl('')
    });
  }

  public ngOnInit(): void { }

  setTerminalData() {

    this.countries = this._merchantTerminalsLink.locationData.countries;
    this.regions = this._merchantTerminalsLink.locationData.regions;
    this.areas = this._merchantTerminalsLink.locationData.areas;
    this._addUpdateMerchantViewModel = this._merchantTerminalsLink.merchant;
    this._contactDetailsViewModel = this._merchantTerminalsLink.contact;

    for (var i = 0; i < this.deviceList.length; i++) {
      this.deviceList[i].merchantNumber = this._merchantTerminalsLink.merchant.merchantNumber;
      this.deviceList[i].merchantName = this._merchantTerminalsLink.merchant.shopName;
      this.TerminalContacts[i].merchantNumber = this._merchantTerminalsLink.merchant.merchantNumber;

      if (this.deviceList[i].sameAsMerchantAddress) {
        let _contact = {
          merchantNumber: this._merchantTerminalsLink.merchant.merchantNumber,
          terminalId: this.deviceList[i].terminalId,
          nameSurname: this._merchantTerminalsLink.contact.firstName + " " + this._merchantTerminalsLink.contact.surname,
          email: this._merchantTerminalsLink.contact.emailAddress,
          cell: this._merchantTerminalsLink.contact.mobileNumber,
          address: this._merchantTerminalsLink.merchant.merchantStreetAddress,
          region: this._merchantTerminalsLink.merchant.regionCode,
          city: this._merchantTerminalsLink.merchant.city,
          postalcode: this._merchantTerminalsLink.merchant.postalServiceCode,// this.TerminalFormGroup.controls['postalcode'].value,
          country: this._merchantTerminalsLink.merchant.countryCode

        } as TerminalContactsViewModel;

        this.deviceList[i].TerminalContactsViewModel = _contact;
        for (var j = 0; j < this.TerminalContacts.length; j++) {

          if (this.TerminalContacts[j].terminalId == this.deviceList[i].terminalId) {
            this.deviceList[i].TerminalContactsViewModel = _contact;
            this.TerminalContacts[j] = _contact;
            break;
          }
        }
      }
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.TerminalFormGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  isFormValid(): CreateResult {
    return this.formValidation(this.TerminalFormGroup, {
      message: "Terminal details is invalid, Please fill in all required fields.",
      success: false
    })
  }

  public onBulkOrderChange(event: Event): void {

    if (this.TerminalFormGroup.controls['bulkOrder'].value == true) {
      this.validateFormControls();
    }
    else {
      this.enableFormControls();
      this.clearbulkOrderData();
      this.isbulkOrder = false;
      this.btnAddTerminal = true;
      this.deviceList = [];
      this.TerminalContacts = [];
      this.bulkOrderConfirmation = "";
    }
    this._merchantTerminalsLink.isbulkOrder = this.TerminalFormGroup.controls['bulkOrder'].value;

  }

  validateFormControls() {

    if (!this.isFormValid().success) {
      this.TerminalFormGroup.controls['bulkOrder'].setValue(false);
      this.isbulkOrder = false;
      return;
    }
    else {
      this.isbulkOrder = true;
      this.disableFormControls();
    }
  }

  disableFormControls() {

    Object.keys(this.TerminalFormGroup.controls).forEach(key => {


      if (key != "terminalId" && key != "bulkOrder" && key != "numberOfTerminals") {
        this.TerminalFormGroup.controls[key].disable();
      }
    });
  }

  enableFormControls() {
    if (this.TerminalFormGroup.controls['sameAsMerchantAddress'].value == true) {
      Object.keys(this.TerminalFormGroup.controls).forEach(key => {

        if (key != "address" && key != "country" && key != "region" && key != "city" && key != "postalcode") {
          this.TerminalFormGroup.controls[key].enable();
        }
      });
    }
    else {
      Object.keys(this.TerminalFormGroup.controls).forEach(key => {
        this.TerminalFormGroup.controls[key].enable();
      });
    }
  }

  clearbulkOrderData() {
    this.isbulkOrder = false;
    this.TerminalFormGroup.controls["numberOfTerminals"].setValue('');
  }

  validateIntegerValue() {

    const value = this.TerminalFormGroup.controls['numberOfTerminals'].value;
    if (Number.isInteger(+value)) {
      return null;
    }
    return { notInteger: true };
  }

  restrictNumeric(event: KeyboardEvent): void {
    const charCode = event.charCode;
    if (charCode !== 0 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  public async addTerminals() {
    this._ngxUiLoaderService.start();
    
    if (this.isbulkOrder && (this.TerminalFormGroup.controls["numberOfTerminals"].value <= 1 || this.TerminalFormGroup.controls["numberOfTerminals"].value == '' || this.TerminalFormGroup.controls["numberOfTerminals"].value == null)) {
      return this.showStaticAndPopupError({
        message: "'Number of terminals' is required for bulk order and cannot be equals to 1.",
        success: false
      }, this._toastService);
    }

    if (!this.isFormValid().success) {
      return;
    }

    this._merchantTerminalsLink.capabCommsProd = {
      productProfile: this.proList.find(item => item.id === this.TerminalFormGroup.controls['productProfile'].value).text,
      terminalCapabilities: this.capList.find(item => item.id === this.TerminalFormGroup.controls['terminalCapabilities'].value).text,
      commsProfile: this.comList.find(item => item.id === this.TerminalFormGroup.controls['commsProfile'].value).text
    }

    let term = this.newTerminal(this.TerminalFormGroup.controls['terminalId'].value, this.TerminalFormGroup.controls['terminalNumber'].value);
    let terminalContact = this.newTerminalContact(this.TerminalFormGroup.controls['terminalId'].value);

    for (var i = 0; i < this.deviceList.length; i++) {
      if (term.terminalId === this.deviceList[i].terminalId) {
        return this.showStaticAndPopupError({
          message: `Terminal ${term.terminalId}, already exist in your list`,
          success: false
        }, this._toastService);
      }
      if (term.terminalNumber === this.deviceList[i].terminalNumber) {
        return this.showStaticAndPopupError({
          message: `Terminal number ${term.terminalNumber}, already exist in your list`,
          success: false
        }, this._toastService);
      }
    }

    var getTerminal = await this._terminalService.Get(this.TerminalFormGroup.controls['terminalId'].value) as TerminalViewModel;
    if (getTerminal != null) {
      return this.showStaticAndPopupError({
        message: 'Terminal already exist, provide a unique terminal Id.',
        success: false
      }, this._toastService);
    }

    var terminalNumberExist = await this._terminalService.TerminalNumberExists(this.TerminalFormGroup.controls['terminalNumber'].value, this._merchantTerminalsLink.merchant.merchantNumber) as boolean;
    if (terminalNumberExist === true) {
      return this.showStaticAndPopupError({
        message: `Terminal number ${this.TerminalFormGroup.controls['terminalNumber'].value} exist, provide a unique terminal number.`,
        success: false
      }, this._toastService);
    }

    if (this.isbulkOrder && this.TerminalFormGroup.controls["numberOfTerminals"].value > 0) {
      debugger;
      this.TerminalFormGroup.controls['numberOfTerminals'].disable();
      this.btnAddTerminal = false;


      var getLastTermNumber = await this._terminalService.GetLastTermNumber(this._merchantTerminalsLink.merchant.merchantNumber);
      this._ngxUiLoaderService.stop();
      this._ngxUiLoaderService.start();
      const generatedValues: string[] = await this.generateTerminalIds(this.TerminalFormGroup.controls["terminalId"].value, this.TerminalFormGroup.controls["numberOfTerminals"].value);

      let terminalcounter: number = Number(getLastTermNumber);

      generatedValues.forEach(async uniqueTerminalId => {
        terminalcounter++;
        console.log(uniqueTerminalId);
        var teminalContact = this.newTerminalContact(uniqueTerminalId);
        this.TerminalContacts.push(teminalContact);
        var term = this.newTerminal(uniqueTerminalId, terminalcounter);
        term.TerminalContactsViewModel = teminalContact;
        this.deviceList.push(term);
      });

      this.bulkOrderConfirmation = generatedValues.length + " added successfully.";
    }
    else {
    
      this.TerminalContacts.push(terminalContact);
      term.TerminalContactsViewModel = terminalContact;
      this.deviceList.push(term);

      if (this.deviceList.length > 1) {
        // Check if all items have the same address
        const allSameAddress = this.deviceList.every(
          device => device.TerminalContactsViewModel.address === terminalContact.address
        );

        // Set the bulk property based on the address condition
        this.deviceList.forEach(device => device.bulkOrder = allSameAddress);
      }

      this.isbulkOrder = false;
      this.TerminalFormGroup.controls['bulkOrder'].disable();
      this.btnAddTerminal = true;

      //this._ngxUiLoaderService.stop();
      return;
    }

    this._ngxUiLoaderService.stop();

  }

  private ShowError(errorMessage: string) {
    return this.showError({
      message: errorMessage,
      success: false
    });
  }

  public async viewbulkOrders() {
    this._ngxUiLoaderService.start();

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Terminals details";

    let counter = 0;
    var str = [];
    this.deviceList.forEach(async terminal => {
      counter++;
      str.push("Terminal (" + counter + "): " + terminal.terminalId + ", term nr: " + terminal.terminalNumber + ", Make & Model: " + terminal.deviceMake + " " + terminal.deviceModel);

    });
    dialogRef.componentInstance.listMessage = str;


    this._ngxUiLoaderService.stop();
  }

  public async deleteAllRow() {
    this.enableFormControls();
    this.clearbulkOrderData();
    this.isbulkOrder = false;
    this.btnAddTerminal = true;
    this.deviceList = [];
    this.TerminalContacts = [];
    this.bulkOrderConfirmation = "";
    this._merchantTerminalsLink.isbulkOrder = false;
  }

  private newTerminalContact(terminalId: string) {
    return {
      merchantNumber: this._merchantTerminalsLink.merchant.merchantNumber,
      terminalId: terminalId,
      nameSurname: this._merchantTerminalsLink.contact.firstName + " " + this._merchantTerminalsLink.contact.surname,
      email: this._merchantTerminalsLink.contact.emailAddress,
      cell: this._merchantTerminalsLink.contact.mobileNumber,
      address: this.TerminalFormGroup.controls['address'].value,
      region: this.TerminalFormGroup.controls['region'].value,
      city: this.TerminalFormGroup.controls['sameAsMerchantAddress'].value == true ? this.TerminalFormGroup.controls['city'].value : this.TerminalFormGroup.controls['city'].value['Area'],
      postalcode: this.TerminalFormGroup.controls['postalcode'].value,
      country: this.TerminalFormGroup.controls["country"].value
    } as TerminalContactsViewModel;
  }

  private newTerminal(terminalId: string, terminalNumber: number) {
    return {
      terminalConfigId: this.merchantTerminalDefaultConfig.terminalConfig,
      merchantNumber: this._addUpdateMerchantViewModel.merchantNumber,
      merchantName: this._addUpdateMerchantViewModel.shopName,
      bulkOrder: this.TerminalFormGroup.controls['bulkOrder'].value,
      contactless: this.TerminalFormGroup.controls['isContactless'].value == '' ? false : this.TerminalFormGroup.controls['isContactless'].value,
      deliveryMethod: this.TerminalFormGroup.controls['terminaldelivery'].value,
      deviceMake: this.deviceMakeList.find(item => item.id === this.TerminalFormGroup.controls['deviceMake'].value).text,
      deviceModel: this.deviceModelList.find(item => item.id === this.TerminalFormGroup.controls['deviceModel'].value).text,
      manualPanEntry: false,
      sameAsMerchantAddress: this.TerminalFormGroup.controls['sameAsMerchantAddress'].value,
      terminalActive: this.TerminalFormGroup.controls['isTerminalActive'].value == '' ? false : this.TerminalFormGroup.controls['isTerminalActive'].value,
      productProfile: this.TerminalFormGroup.controls['productProfile'].value,
      terminalCapabilities: this.TerminalFormGroup.controls['terminalCapabilities'].value,
      commsProfile: this.TerminalFormGroup.controls['commsProfile'].value,
      terminalId: terminalId,
      terminalNumber: (terminalNumber != null && terminalNumber > 0) ? terminalNumber : this.TerminalFormGroup.controls['terminalNumber'].value,
      terminalType: this.merchantTerminalDefaultConfig.terminalType,
      deviceOwnership: this.TerminalFormGroup.controls['deviceOwnership'].value,
      bankingWindowTime: this.TerminalFormGroup.controls['bankingWindowTime'].value,
      parameterDownloadDay: this.TerminalFormGroup.controls['parameterDownloadDay'].value,
      parameterDownloadWindowTime: this.TerminalFormGroup.controls['parameterDownloadWindowTime'].value,
    } as TerminalSignUpDownloadModel;
  }

  async generateTerminalIds(initialValue: string, count: number): Promise<string[]> {
    debugger;
    const values: string[] = [];

    // Extract the prefix and numeric part using regex
    const match = initialValue.match(/^(.*?)(\d+)$/);
    if (!match) {
      // If format doesn't match, return the same value multiple times
      return Array(count).fill(initialValue);
    }

    const prefix: string = match[1];
    const numericPart: string = match[2];

    // Parse the numeric part to an integer
    let currentNumber: number = parseInt(numericPart, 10);

    // Generate the required number of values
    while (values.length < count) {
      // Increment the numeric part
      //currentNumber++;

      // Format the new value with the same number of digits
      const newNumericPart: string = currentNumber.toString().padStart(numericPart.length, '0');

      // Concatenate the prefix with the new numeric part
      let newValue: string = prefix + newNumericPart;

      // Check if the value already exists in the database
      let term = await this._terminalService.Get(newValue);
      while (term != null) {
        // Regenerate value
        currentNumber++;
        const newNumericPart: string = currentNumber.toString().padStart(numericPart.length, '0');
        newValue = prefix + newNumericPart;
        term = await this._terminalService.Get(newValue);
      }

      // Add the new value to the list
      values.push(newValue);

      currentNumber++;
    }

    return values;
  }

  private getTerminalList(): AddUpdateTerminalSignUpViewModel[] {

    if (this.terminalList.length === 0 || this.terminalList.length === -1) {
      for (let i = 0; i <= (this.deviceList.length - 1); i++) {

        this.terminalList.push({
          terminalConfigId: this.deviceList[i].terminalConfigId,
          terminalId: this.deviceList[i].terminalId,
          merchantNumber: this.deviceList[i].merchantNumber,
          merchantName: this.deviceList[i].merchantName,
          terminalNumber: Number(this.deviceList[i].terminalNumber),
          terminalType: this.deviceList[i].terminalType,
          productProfile: Number(this.TerminalFormGroup.controls['productProfile'].value),
          terminalCapabilities: Number(this.TerminalFormGroup.controls['terminalCapabilities'].value),
          commsProfile: Number(this.TerminalFormGroup.controls['commsProfile'].value),
          manualPanEntry: false,
          terminalActive: this.deviceList[i].terminalActive,
          contactless: this.deviceList[i].contactless,
          sameAsMerchantAddress: this.deviceList[i].sameAsMerchantAddress,
          deviceMake: this.deviceMakeList.find(item => item.text === this.deviceList[i].deviceMake).id,
          deviceModel: this.deviceModelList.find(item => item.text === this.deviceList[i].deviceModel).id,
          retail: this.TerminalFormGroup.controls['retail'].value.map(x => x.item_text).join(', '),
          admin: this.TerminalFormGroup.controls['admin'].value.map(x => x.item_text).join(', '),
          deliveryMethod: this.deviceList[i].deliveryMethod,
          bulkOrder: this.deviceList[i].bulkOrder,
          deviceOwnership: this.deviceList[i].deviceOwnership
        });
      }
    }
    return this.terminalList;
  }

  getDownloadBanking(): AddUpdateTerminalInteractionViewModel[] {
    if (this.bankingParamDownlWindowUpdateAll.length === 0 || this.bankingParamDownlWindowUpdateAll.length === -1) {
      for (let i = 0; i <= (this.deviceList.length - 1); i++) {
        this.bankingParamDownlWindowUpdateAll.push({
          terminalId: this.deviceList[i].terminalId,
          BankingWindow: this.deviceList[i].bankingWindowTime,
          InteractionDay: Number(this.deviceList[i].parameterDownloadDay),
          InteractionTime: this.deviceList[i].parameterDownloadWindowTime
        });
      }
    }
    return this.bankingParamDownlWindowUpdateAll;;
  }

  getTerminalNotes(): TerminalSignUpNotesViewModel[] {
    for (let i = 0; i <= (this.deviceList.length - 1); i++) {
      if (this._merchantTerminalsLink.notes !== '' && this._merchantTerminalsLink.notes !== undefined) {
        this.TerminalNotes.push({
          terminalId: this.deviceList[i].terminalId,
          merchantNumber: this._addUpdateMerchantViewModel.merchantNumber,
          notes: this._merchantTerminalsLink.notes,
          changedBy: '',
          changedOn: new Date,
          source: '',
          id: 0,
          userId: ''
        });
      }
    }
    return this.TerminalNotes;
  }

  async saveTerminalSignup(): Promise<CreateResult> {
    var getTerminals = this.getTerminalList();
    return await this._terminalService.AddMutlipleTerminals(getTerminals, this.TerminalFormGroup.controls["terminaldelivery"].value);
  }

  async activateTerminals(): Promise<CreateResult> {
    return await this._terminalService.ActivateTerminalsByMerchantNr(this.terminalList);
  }

  async saveTerminalContact(): Promise<CreateResult> {
    return await this._terminalService.AddTerminalContacts(this.TerminalContacts);
  }

  async SendNotification(): Promise<CreateResult> {
    return await this._terminalService.SendNotification(this.terminalList, "merchant");
  }

  async saveTerminalInteractions(): Promise<CreateResult> {
    return await this._terminalService.AddUpdateAllTerminalInteractions(this.getDownloadBanking());
  }

  async saveNotes(): Promise<CreateResult> {
    this.TerminalNotes = this.getTerminalNotes();
    if (this.TerminalNotes.length > 0) {
      return await this._terminalService.AddTerminalSignUpNote(this.TerminalNotes);
    }
    return await { success: true, message: "notes is not included", } as CreateResult;
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({ end }) {
    if (this.loading || this.areas.length <= this.areaBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.areaBuffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.areaBuffer.length;
    const more = this.areas.slice(len, this.bufferSize + len);
    this.loading = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading = false;
      this.areaBuffer = this.areaBuffer.concat(more);
    }, 200)
  }

  get form() { return this.TerminalFormGroup.controls; }
  get terminals() { return this.form['terminals'] as FormArray }
  get allTerminals(): FormArray { return this.TerminalFormGroup.get('terminals') as FormArray; }

  public ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public deleteTerminal(index: number) {
    this.terminalCount--;
    this.allTerminals.removeAt(index);

  }

  public displayAdditionaControls(index: number): boolean {
    return false;
  }

  public async onChangeCountry(event: string): Promise<void> {
    this.regions = (await this._merchantService.GetRegions()).map((x) => {
      return { id: x.regionCode, text: x.regionName }
    });
  }
  

  onChangeRegion(event) {
    this.TerminalFormGroup.controls["region"].setValue(event);
  }

  onChangeCity(cityValue) {
    if (cityValue != null && cityValue != '' && cityValue != undefined) {
      if (cityValue['StrCode'] != null && cityValue['StrCode'] != '' && cityValue['StrCode'] != undefined) {
        this.TerminalFormGroup.controls["postalcode"].setValue(cityValue['StrCode']);
      }
    }
  }

  public async onMakeChange(deviceId: number): Promise<void> {
    if (deviceId > 0) {
      this.deviceModels = (await this._terminalService.GetDeviceModelsByDeviceId(deviceId)).map((x) => {
        return { id: x.id.toString(), text: x.model }
      });
    }
  }

  async onDeviceModelChange(index: number, selectedModel: any) {
    if (typeof selectedModel === 'number' || typeof selectedModel === 'string') {
      var val;
      if (selectedModel.toString().length < 3) {
        val = this.deviceModels.find(x => x.id == "" + selectedModel);
      } else {
        val = this.deviceModels.find(x => x.text == "" + selectedModel);
      }
      if (val != undefined) {
        this.allTerminals.at(index).get('deviceModel')?.setValue(val);
        this.allTerminals.at(index).get('deviceModel')?.patchValue(this.deviceModels);
        this.cdr.detectChanges();
      }
    }
    else {
      //this.allTerminals.at(index).get('deviceModel')?.setValue(this.deviceModelList); // Set a default value
    }
  }

  public GetDeviceMake(id: string) {
    if (parseInt(id) >= 0) {
      const foundItem = this.deviceMakeList.find(item => item.id === id);
      return foundItem;
    }
    return "";
  }

  public GetDeviceModel(id: any) {
    if (parseInt(id) >= 0) {
      const foundItem = this.deviceModels.find(item => item.id === id);
      return foundItem;
    }
    return "";
  }

  public decodeNameLocation(nameLocation: string): DecodedNameLocation {
    return {
      shopName: nameLocation.substring(0, 23).trim(),
      city: nameLocation.substring(23, 36).trim(),
      region: nameLocation.substring(36, 38).trim(),
      country: nameLocation.substring(38, 40).trim(),
    };
  }

  setDeliveryAddress(useMerchantAddress) {

    let fields = ['nameSurname', 'address', 'region', 'country', 'city', 'postalcode', 'cell', 'emailAddress'];
    if (useMerchantAddress === true) {

      this.TerminalFormGroup.controls['address'].setValue(this._merchantTerminalsLink.merchant.merchantStreetAddress);
      this.TerminalFormGroup.controls['region'].setValue(this._merchantTerminalsLink.merchant.regionCode);
      this.TerminalFormGroup.controls['postalcode'].setValue(this._merchantTerminalsLink.merchant.postalServiceCode);
      this.TerminalFormGroup.controls['country'].setValue(this._merchantTerminalsLink.merchant.countryCode);
      this.TerminalFormGroup.controls['city'].setValue(this._merchantTerminalsLink.merchant.city);
      this.TerminalFormGroup.controls['emailAddress'].setValue(this._merchantTerminalsLink.contact.emailAddress);
      this.TerminalFormGroup.controls['cell'].setValue(this._merchantTerminalsLink.merchant.customerServicePhoneNo);
      for (const fieldName of fields) {
        if (this.TerminalFormGroup.get(fieldName).value != '' && this.TerminalFormGroup.get(fieldName).value != null) {
          this.TerminalFormGroup.get(fieldName).disable();
        }
      }
    }
    else {
      for (const fieldName of fields) {
        this.TerminalFormGroup.controls[fieldName].setValue('');
        this.TerminalFormGroup.get(fieldName).enable();
      }
    }
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      let c = e.target.value;
      let vl = e.target.value;
    } else {
      return;
    }
  }
  selectedItems: any[] = [];

  onItemSelect(item: any) {
    const exists = this.selectedItems.some(x => x.item_id === item.item_id);
    if (!exists) {
      this.selectedItems.push(item);
    }
  }

  onItemDeSelect(item: any) {
    const idx = this.selectedItems.findIndex(x => x.item_id === item.item_id);
    if (idx > -1) {
      this.selectedItems.splice(idx, 1);
    }
  }

  onSelectAll(items: any[]) {
    this.selectedItems = [...items];
  }

  onUnSelectAll() {
    this.selectedItems.length = 0;
  }

  deleteRow(terminalId: string) {
    const index = this.deviceList.findIndex(x => x.terminalId == terminalId);
    if (index > -1) {

      this.deviceList.splice(index, 1);
      this.TerminalContacts.splice(index, 1);
      this.terminalList.splice(index, 1);
      debugger;
      if (this.deviceList.length > 1) {
        // Check if all items have the same address
        const allSameAddress = this.deviceList.every(
          device => device.TerminalContactsViewModel.address === this.deviceList[0].TerminalContactsViewModel.address
        );

        // Set the bulk property based on the address condition
        this.deviceList.forEach(device => device.bulkOrder = allSameAddress);
      }
      else {
        this.deviceList.forEach(device => device.bulkOrder = false);
      }
    }

    if (this.deviceList.length <= 0) {
      this.TerminalFormGroup.controls['bulkOrder'].enable();
    }
  }

  viewContacts(terminalId: string) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Terminal details";

    let contact = this.TerminalContacts.find(x => x.terminalId == terminalId);
    let term = this.deviceList.find(x => x.terminalId == terminalId);
    var str = [];
    str.push("Name & Surname: " + contact.nameSurname);
    str.push("Cell number: " + contact.cell);
    str.push("Email address: " + contact.email);
    str.push("Delivery address: " + contact.address);
    str.push("Region: " + contact.region);
    str.push("City: " + contact.city);
    str.push("Postal Service Code: " + contact.postalcode);
    str.push("Country: " + contact.country);
    str.push("Banking window: " + term.bankingWindowTime);
    str.push("Parameter download day: " + term.parameterDownloadDay);
    str.push("Parameter download window: " + term.parameterDownloadWindowTime);
    dialogRef.componentInstance.listMessage = str;
  }
}


